import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";

const InternalLink = forwardRef(({ to, ...rest }, ref) => {
  return (
    <Link component={RouterLink} underline="none" to={to} {...rest} ref={ref} />
  );
});

export default InternalLink;
